import { IStatus } from 'src/libraries/thunk.library';
import { actionTypes, IAdminState } from 'src/ducks/admin.duck';

export const getAdminStatus = (
  state: IAdminState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
